import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import './SignIn.css';

function ConfirmPhone() {
    const [phoneCode, setPhoneCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const location = useLocation();

    const email = location.state?.email;

    useEffect(() => {
        if (!email) {
            toast.error("⚠️ Email məlumatı yoxdur. Zəhmət olmasa qeydiyyatı yenidən edin.");
            setTimeout(() => {
                navigate("/qeydiyyat");
            }, 2000);
        }
    }, [email, navigate]);

    const handleConfirm = async (e) => {
        e.preventDefault();
        
        if (!email) return;

        if (!phoneCode) {
            setErrorMessage("Telefon kodunu daxil edin!");
            return toast.warn("⚠️ Telefon kodunu daxil edin!");
        }
    
        setLoading(true);
        setErrorMessage("");

        try {
            const response = await axios.post("https://api.herracim.az/api/Account/confirm", {
                email,
                phoneCode
            });
    
            if (response.status === 200) {
                toast.success("✅ Qeydiyyat uğurla tamamlandı!");
                setTimeout(() => {
                    navigate("/sign-in", {
                        state: {
                            message: "Hesabınız təsdiqləndi! İndi giriş edə bilərsiniz.",
                            email: email
                        }
                    });
                }, 2000);
            }
        } catch (err) {
            console.error("🚨 Təsdiq xətası:", err);
            let errorMsg = "Kod səhvdir və ya istifadəçi tapılmadı";
    
            if (typeof err.response?.data === "string") {
                errorMsg = err.response.data;
            } else if (typeof err.response?.data === "object") {
                const obj = err.response.data;
                const allMessages = [];
    
                for (let key in obj) {
                    if (Array.isArray(obj[key])) {
                        allMessages.push(...obj[key]);
                    } else {
                        allMessages.push(obj[key]);
                    }
                }
    
                if (allMessages.length > 0) {
                    errorMsg = allMessages.join(" | ");
                }
            }
    
            setErrorMessage(errorMsg);
            toast.error(`❌ ${errorMsg}`);
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div className="herrac-confirm-wrapper">
            <div className="herrac-confirm-overlay"></div>

            <div className="herrac-confirm-container">
                <Link to="/giris" className="herrac-confirm-close" aria-label="Bağla">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </Link>

                <div className="herrac-confirm-card">
                    <div className="herrac-confirm-header">
                        <div className="herrac-confirm-icon">
                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                <circle cx="24" cy="24" r="22" stroke="url(#gradient4)" strokeWidth="2"/>
                                <rect x="16" y="12" width="16" height="24" rx="2" stroke="url(#gradient4)" strokeWidth="2"/>
                                <path d="M22 32H26" stroke="url(#gradient4)" strokeWidth="2" strokeLinecap="round"/>
                                <defs>
                                    <linearGradient id="gradient4" x1="0" y1="0" x2="48" y2="48">
                                        <stop offset="0%" stopColor="#4facfe"/>
                                        <stop offset="100%" stopColor="#00f2fe"/>
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <h2 className="herrac-confirm-title">Telefon Təsdiqi</h2>
                        <p className="herrac-confirm-subtitle">SMS ilə göndərilən kodu daxil edin</p>
                    </div>

                    {email && (
                        <div className="herrac-confirm-email-display">
                            📧 {email}
                        </div>
                    )}

                    <form className="herrac-confirm-form" onSubmit={handleConfirm}>
                        <div className="herrac-confirm-input-group">
                            <label className="herrac-confirm-label">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.8333 3.75H4.16667C3.24619 3.75 2.5 4.49619 2.5 5.41667V14.5833C2.5 15.5038 3.24619 16.25 4.16667 16.25H15.8333C16.7538 16.25 17.5 15.5038 17.5 14.5833V5.41667C17.5 4.49619 16.7538 3.75 15.8333 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M6.66667 7.5V12.5M10 7.5V12.5M13.3333 7.5V12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Telefon təsdiq kodu
                            </label>
                            <input
                                type="text"
                                placeholder="000000"
                                value={phoneCode}
                                onChange={(e) => setPhoneCode(e.target.value.replace(/\D/g, ""))}
                                className="herrac-confirm-input"
                                required
                                disabled={loading}
                                maxLength={6}
                            />
                        </div>

                        {errorMessage && (
                            <div className="herrac-confirm-error" role="alert">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10 6.66667V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10 13.3333H10.0083" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                {errorMessage}
                            </div>
                        )}

                        <button 
                            type="submit" 
                            className="herrac-confirm-button" 
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="herrac-confirm-spinner"></span>
                                    Təsdiqlənir...
                                </>
                            ) : (
                                <>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M16.6667 5L7.5 14.1667L3.33333 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Təsdiqlə
                                </>
                            )}
                        </button>
                    </form>

                    <div className="herrac-confirm-footer">
                        <Link to="/giris" className="herrac-confirm-footer-link">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Giriş səhifəsinə qayıt
                        </Link>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                theme="light"
                style={{ zIndex: 99999 }}
            />
        </div>
    );
}

export default ConfirmPhone;